import { defineComponent as _defineComponent } from 'vue';
import Preview from '@blade-sxp/monitoring-center/pages/preview/index.vue';
import Alarm from '@blade-sxp/monitoring-center/pages/alarm/index.vue';
import Snap from '@blade-sxp/monitoring-center/pages/snap/index.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        return { __sfc: true, Preview, Alarm, Snap };
    }
});
